import cn from "classnames";

import styles from "./preloader.module.scss";

const Preloader = (props) => {
  const { isChildPreloader, isAbsolute, title } = props;

  return (
    <div
      className={cn(styles["container"], {
        [styles["container-child-preloader"]]: isChildPreloader,
        [styles["absolute"]]: isAbsolute
      })}
    >
      {title && <h3 className={styles["loader__title"]}>{title}</h3>}
      <div className={styles["loader"]}></div>
    </div>
  );
};

export default Preloader;
